import React, { Component } from 'react';
import { strings } from '../utils/translations';
import styles from './modal.module.scss';
import classnames from 'classnames';
import CloseIcon from '../../img/icons/closeIcon';
import DownloadFileIcon from '../../img/files.png';
import PrimaryButton from '../Buttons/primaryButton';
import Alert from '../Alert/alert';
import CsvTemplate from '../../img/plantilla-de-importacion-usuarios-homyhub.csv';

import { Tabs , notification} from 'antd';
//import 'antd/es/tabs/style/css';
import { CSVReader } from 'react-papaparse';
// import excel from 'xlsx';

export default class ImportUsersModal extends Component
{    
    constructor(props)
    {
        super(props);

        this.state =
        {
            onClickClose: props.onClickClose,
            usersUploaded: [],
            importedUsers: []
        }
        
        this.fileRef = React.createRef()
        this.manualUsersText = ""
    }


    render()
    {
        const { TabPane } = Tabs

        return(
        <>
            <div className={styles.overlay}></div>
            <div className={ classnames([styles.modal, styles.importUsers]) }>
                <div className={styles.modalTopBar}>
                    <h3 className={styles.title}>{ strings('giveVRImport') }</h3>
                    <CloseIcon className={styles.closeIcon} size="16" onClick={this.state.onClickClose} />
                </div>
                <div className="tabsContainer">
                    <Tabs defaultActiveKey="csv">
                        <TabPane tab="CSV" key="csv">
                            <div className={styles.contentBox}>
                                <div className={ classnames([styles.box, styles.importElements])}>
                                    <h4 className={styles.subtitle}>{ strings('giveVRImportDragFile') }</h4>
                                    <div className={styles.dropContent}>
                                        <CSVReader
                                            ref={(ref) => {this.fileRef = ref}}
                                            onDrop={this.handleOnDrop.bind(this)}
                                            onError={this.handleOnError.bind(this)}
                                            onRemoveFile={this.handleRemoveFile.bind(this)}
                                            addRemoveButton
                                            removeButtonColor="#e6e6eb"
                                        >
                                            {
                                                (this.state.importedUsers.length === 0) &&
                                                <img className={styles.importIcon} src={DownloadFileIcon} />
                                            }
                                            <span>{ strings('giveVRImportDragText') }</span>
                                        </CSVReader>
                                    </div>
                                </div>
                                <div className={styles.downloadBtn}>
                                    <a
                                        className={styles.link}
                                        href={CsvTemplate}
								        download="plantilla-de-importacion-usuarios-homyhub"
                                    >
                                        { strings('giveVRImportDownload') }
                                    </a>
                                    {
                                        (this.state.importedUsers.length > 0) &&
                                        <PrimaryButton
                                            text={strings('giveVRImportButton')}
                                            style={{ margin: 0}}
                                            onClick={() => this.importCSVUsers()}
                                        />
                                    }
                                </div>
                            </div>
                        </TabPane>
                        {/*<TabPane tab="XLSX, XLS" key="xlsx">
                            <div className={styles.contentBox}>
                                <div className={ classnames([styles.box, styles.importElements])}>
                                    <div className={styles.leftBlock}>
                                        <h4 className={styles.subtitle}>Arrastra tu archivo</h4>
                                        <div className={styles.dropContent}>
                                            <p className={styles.text}>También puedes seleccionarlo
                                                <a className={styles.link}>
                                                    aquí
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div className={styles.rightBlock}>
                                        <img className={styles.importIcon} src={DownloadFileIcon} />
                                    </div>
                                </div>
                                <div className={styles.downloadBtn}>
                                    <a
                                        className={styles.link}
                                        onClick=''
                                    >Descarga nuestra plantilla de importación</a>
                                    <PrimaryButton
                                        text="Importar"
                                        style={{ margin: 0}}
                                        onClick={() => this.importXLSXUsers()}
                                    />
                                </div>
                            </div>
                        </TabPane>*/}
                        <TabPane tab="Manual" key="manual">
                            <div className={styles.contentBox}>
                                <div className={ classnames([styles.box, styles.textContacts])}>
                                <textarea
                                    className={styles.textarea}
                                    type='text'
                                    rows="8"
                                    placeholder={strings('giveVRImportInstructions')}
                                    onChange={(e) => this.manualUsersText = e.target.value}
                                />
                                </div>
                                <div className={styles.downloadBtn}>
                                    <a
                                        className={styles.link}
                                        onClick=''
                                    >
                                        { strings('giveVRImportDownload') }
                                    </a>
                                    
                                    <PrimaryButton
                                        text={strings('giveVRImport')}
                                        style={{ margin: 0}}
                                        onClick={() => this.importManualContacts()}
                                    />
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </>)
    }
    

    handleRemoveFile(e)
    {
        console.log(this.fileRef)
        console.log(this)
        if (this.fileRef.current)
            this.fileRef.current.removeFile(e)
        
        this.setState({ importedUsers: [] })
    }
    handleOnDrop(data)
    {
        if (data == null || data.length <= 1) return
        
        // Remove first line of the template
        data.splice(0,1)
        
        let importedUsers = 
        data.filter(u => (u.data[0].trim().length > 0 &&
                          (u.data[1].trim().length > 0 || u.data[2].trim().length > 0)
                         ))
        importedUsers = importedUsers.map(u => ({
            name: u.data[0],
            email: u.data[1] ? u.data[1].trim() : '',
            phoneNumber: u.data[2] ? u.data[2].trim() : ''
        }))
        console.log(importedUsers)
        
        this.setState({ importedUsers })
    }
    handleOnError(err, file, inputElem, reason)
    {
        console.log(err)
        notification.error(
        {
            message: err,
            placement: 'top'
        })
    }


    importCSVUsers()
    {
        this.setState(
        {
            usersUploaded: [...this.state.importedUsers]
        }, () =>
        {
            notification.success(
			{
				message: `${this.state.importedUsers.length} usuarios importados correctamente`,
				placement: 'top'
			})
            this.props.onUsersFileUploaded(this.state.usersUploaded)
            this.close()
        })
    }

    importXLSXUsers()
    {
        // let file = excel.readFile(file);
        this.close();
    }

    importManualContacts()
    {
        if (this.manualUsersText.trim().length === 0)
        {
            notification.error(
			{
				message: strings('fillInAllTheFields'),
				placement: 'top'
			})
            return
        }
        
        let dividedImportedUsersFinal = []
        let dividedImportedUsers = this.manualUsersText.split(/\r?\n/)
        for (let i = 0; i < dividedImportedUsers.length; i++)
        {
            let u = dividedImportedUsers[i]
            let user = u.split(";")
            
            if (user.length < 2 || user[0].trim().length === 0 || (user.length > 2 && user[1].trim().length === 0 && user[2].trim().length === 0))
                continue
                
            dividedImportedUsersFinal.push({ name: user[0].trim(), email: (user[1] != null) ? user[1].trim() : '', phoneNumber: (user[2] != null) ? user[2].trim() : '' })
        }
        
        if (dividedImportedUsersFinal.length == 0)
		{
            notification.error(
			{
				message: strings('fillInAllTheFields'),
				placement: 'top'
			})
		}
		else
		{
            this.setState({ importedUsers: dividedImportedUsersFinal })
            
            notification.success(
			{
				message: `${dividedImportedUsersFinal.length} usuarios importados`,
				placement: 'top'
			})

            this.props.onUsersFileUploaded(dividedImportedUsersFinal)
            
            this.close()
        }
    }
    
    
    close()
	{
        this.props.onClickClose()
    }
}